import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/introduction',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue'),
    children: [
      {
        //CA互认简介
        path: '/introduction',
        name: 'introduction',
        component: () => import(/* webpackChunkName: "about" */ '../views/introduction.vue')
      },
      {
        //新闻
        path: '/news',
        name: 'news',
        component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
      },
      {
        //互认标准
        path: '/standard',
        name: 'standard',
        component: () => import(/* webpackChunkName: "about" */ '../views/standard.vue')
      },
      {
        //常见问题
        path: '/problem',
        name: 'problem',
        component: () => import(/* webpackChunkName: "about" */ '../views/problem.vue')
      },
      {
        //互联交易中心
        path: '/tradingCenter',
        name: 'tradingCenter',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/tradingCenter.vue')
      },

      {
        //电子交易系统互联目录
        path: '/tradingSystem',
        name: 'tradingSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/tradingSystem.vue')
      },


      {
        //App加入
        path: '/bidEvaluationTools',
        name: 'bidEvaluationTools',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/bidEvaluationTools.vue')
      },

      {
        //机构加入
        path: '/venueManagementSystem',
        name: 'venueManagementSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueManagementSystem.vue')
      },

      {
        //场地视频会议系统互联目录
        path: '/venueVideoConferencingSystem',
        name: 'venueVideoConferencingSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueVideoConferencingSystem.vue')
      },

    



      
      

      {
        //场地音视频监控工具互联目录
        path: '/venueAudioAndVideoMonitoringTools',
        name: 'venueAudioAndVideoMonitoringTools',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueAudioAndVideoMonitoringTools.vue')
      },

      {
        //评标专家库
        path: '/bidEvaluationExpertDatabase',
        name: 'bidEvaluationExpertDatabase',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/bidEvaluationExpertDatabase.vue')
      },

      {
        //评标专家库
        path: '/expertExtractionTool',
        name: 'expertExtractionTool',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/expertExtractionTool.vue')
      },
      {
        //联系我们
        path: '/contactUs',
        name: 'contactUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/contactUs.vue')
      },

      {
        //标准接口开发指南
        path: '/interfaceGuide',
        name: 'interfaceGuide',
        component: () => import(/* webpackChunkName: "about" */ '../views/interfaceGuide.vue')
      },

      {
        //共享组件标准接口联调
        path: '/interfaceDebug',
        name: 'interfaceDebug',
        component: () => import(/* webpackChunkName: "about" */ '../views/interfaceDebug.vue')
      },

      {
        //共享组件标准接口联调
        path: '/expertLibraryComponent',
        name: 'expertLibraryComponent',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalogCompont/expertLibraryComponent.vue')
      },
      {
        //共享组件标准接口联调
        path: '/bidEvaluationComponent',
        name: 'bidEvaluationComponent',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalogCompont/bidEvaluationComponent.vue')
      },

      {
        //省服务平台
        path: '/provincialServicePlatform',
        name: 'provincialServicePlatform',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/provincialServicePlatform.vue')
      },
      {
        //常见问题
        path: '/askedQuestion',
        name: 'askedQuestion',
        component: () => import(/* webpackChunkName: "about" */ '../views/askedQuestion.vue')
      },
      {
        //常见问题
        path: '/testedit',
        name: 'testedit',
        component: () => import(/* webpackChunkName: "about" */ '../views/testedit2.vue')
      },
      {
        //远程异地项目登记工具
        path: '/remoteRegistrationTool',
        name: 'remoteRegistrationTool',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/remoteRegistrationTool.vue')
      },
      {
        //场所工位预约工具
        path: '/placeReservationTool',
        name: 'placeReservationTool',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/placeReservationTool.vue')
      },
      {
        //门禁系统
        path: '/accessControlSystem',
        name: 'accessControlSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/accessControlSystem.vue')
      },
      {
        //专家抽取终端
        path: '/expertExtractionTerminal',
        name: 'expertExtractionTerminal',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/expertExtractionTerminal.vue')
      },
      {
        //专家签到工作台
        path: '/expertSign',
        name: 'expertSign',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/expertSign.vue')
      },
      {
        //场地专家评标登录工作台
        path: '/expertLogin',
        name: 'expertLogin',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/expertLogin.vue')
      },
    ]
  },
  

  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
